"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_BUTTON_CATEGORY_KEY = 'base';
exports.TOGGLE_BUTTON_COMPONENT_KEY = 'toggleButton';